import React from "react";

import { FormField } from "src/components/Form/fields/FormField.tsx";

import { css } from "@emotion/react";
import { useIsFieldHidden } from "src/components/Form/hooks/useIsFieldHidden.ts";
import { useResourceFormContext as useFormFrameworkContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { getFieldConfig } from "src/components/Form/utils/getFieldConfig.ts";

export const SingleField = ({ name }: { name: string }) => {
  const { isHidden } = useIsFieldHidden({ name });
  const { fields } = useFormFrameworkContext();

  const field = getFieldConfig(fields, name);

  if (isHidden) {
    return null;
  }

  return (
    <div css={rootStyles({ width: field?.width })}>
      <FormField name={name} />
    </div>
  );
};

const rootStyles = ({ width }: { width?: string | number }) => [
  css({
    flexShrink: 0,
    minWidth: 0,
    ...(width != null
      ? { width, flexGrow: 0 }
      : { flexBasis: "1px", flexGrow: 1 }),
  }),
];
